__turbopack_context__.v({
  "articleAdItem": "_6Q5IkG_articleAdItem",
  "articleAdLabel": "_6Q5IkG_articleAdLabel",
  "desktopOnly": "_6Q5IkG_desktopOnly",
  "inArticleAd": "_6Q5IkG_inArticleAd",
  "previewAd": "_6Q5IkG_previewAd",
  "sidebarAdCard": "_6Q5IkG_sidebarAdCard",
  "sidebarCard": "_6Q5IkG_sidebarCard",
  "sidebarLabel": "_6Q5IkG_sidebarLabel",
  "sidebarRailAd": "_6Q5IkG_sidebarRailAd",
  "sidebarRailFrame": "_6Q5IkG_sidebarRailFrame",
  "sidebarSquareCard": "_6Q5IkG_sidebarSquareCard",
  "sidebarSquareFrame": "_6Q5IkG_sidebarSquareFrame",
  "topBanner": "_6Q5IkG_topBanner",
});
